import { render } from "./SortingColumn.vue?vue&type=template&id=21c7115a"
import script from "./SortingColumn.vue?vue&type=script&lang=js"
export * from "./SortingColumn.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dyo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__